const MANAGED_ENTITY_QUERY_NAMES = new Set([
  'ManagedEntitiesOrganizations',
  'ManagedEntitiesProperties',
  'ManagedEntitiesCores',
  'ManagedEntitiesHMMs',
  'ManagedEntitiesBNGs',
  'ManagedEntitiesBuildings',
  'ManagedEntitiesFloors',
  'ManagedEntitiesUnits',
  'ManagedEntitiesPlmEventResponses',
]);

export function shouldRefetchActiveQueryOnReconnect(
  queryName: string | undefined,
): boolean {
  return !queryName || !MANAGED_ENTITY_QUERY_NAMES.has(queryName);
}
